import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DisplayLinkStats } from '../email-stats';

export interface UrlClicked {
  normalizedUrl: string;
  expanded: boolean;
}

@Component({
  selector: 'email-link-performance',
  templateUrl: './link-performance.component.html',
  styleUrls: ['./link-performance.component.scss'],
})
export class LinkPerformanceComponent {
  @Input() linkActivityPath: string;
  @Input() linkActivity: DisplayLinkStats[];
  @Input() backUrl: string;
  @Output() linkExpansionClicked = new EventEmitter<UrlClicked>();

  emitHighlightPreview(normalizedUrl: string, expanded: boolean): void {
    this.linkExpansionClicked.emit({ normalizedUrl, expanded });
  }
}
